import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".8",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "m1.18 11.274 8.608-8.608L8.23 1.108a.408.408 0 0 1 .302-.696l6.608.19c.218.005.389.178.394.394l.19 6.608c.01.371-.438.56-.699.299l-1.557-1.557-8.606 8.61M.266 6.457 4.204 2.52 2.647.96a.406.406 0 0 1 .301-.693l4.163.12M15.618 9.063l.117 3.992c.013.371-.435.56-.696.3l-1.557-1.558-3.939 3.938" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M.066.068h15.867v15.864H.066z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }